import NewspaperIcon from "@mui/icons-material/Newspaper";
import ListAltIcon from "@mui/icons-material/ListAlt";

const menu = [
  {
    id: 3,
    title: "Order Management",
    role: "Order Management",
    icon: <NewspaperIcon />,
    route: "/inputs",
    children: [
      {
        id: 1,
        title: "Add Order",
        role: "Add Order",
        route: "/addOrder",
        icon: <ListAltIcon />,
      },
    ],
  },
];

export default menu;
